/* Glambe: script-made prices follow the visitor's converter currency; cart icon bump; proof block placement */
(function(){
 if(window.__gbfix)return;window.__gbfix=1;
 var SEL='[class*="gbs__"],[class*="gbm__"],[class*="gbb__"],[class*="gbn__"],[class*="gbmenu__"],[class*="gbcc__"],[class*="gbx__"],[class*="gbw__"],[class*="gbq__"]';
 var RX=/AED[\s ]?([0-9][0-9,]*(?:\.[0-9]+)?)/g;
 function ref(){
  var e=document.querySelector('.money[bucks-init][bucks-current]');
  if(!e)return null;
  var init=parseFloat(e.getAttribute('bucks-init')),cur=String(e.getAttribute('bucks-current')||e.textContent),m=cur.match(/^(\D*?)(\d[\d,]*(?:\.\d+)?)(\D*)$/);
  if(!m||!(init>0))return null;
  var num=parseFloat(m[2].replace(/,/g,''));
  if(/^(AED|Dhs)/i.test(m[1].trim()))return null;
  return {r:num/init,p:m[1],s:m[3],d:(m[2].split('.')[1]||'').length,c:m[2].indexOf(',')>-1};
 }
 function fmt(v,R){var s=v.toFixed(R.d);if(R.c){var a=s.split('.');a[0]=a[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');s=a.join('.')}return R.p+s+R.s}
 function aed(a){var s=a.toFixed(2).split('.');s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');return 'AED '+s.join('.')}
 function conv(){
  var R=ref();if(!R)return;
  var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null),n,list=[];
  while((n=w.nextNode())){if(n.nodeValue.indexOf('AED')>-1)list.push(n)}
  list.forEach(function(t){
   var p=t.parentNode;if(!p||!p.closest||p.closest('.money,script,style,[data-aed]')||!p.closest(SEL))return;
   var txt=t.nodeValue,frag=document.createDocumentFragment(),last=0,m;RX.lastIndex=0;
   while((m=RX.exec(txt))){
    frag.appendChild(document.createTextNode(txt.slice(last,m.index)));
    var a=parseFloat(m[1].replace(/,/g,'')),s=document.createElement('span');
    s.setAttribute('data-aed',a);s.textContent=fmt(a*R.r,R);frag.appendChild(s);last=m.index+m[0].length;
   }
   frag.appendChild(document.createTextNode(txt.slice(last)));p.replaceChild(frag,t);
  });
 }
 function rerender(){
  var R=ref();
  [].forEach.call(document.querySelectorAll('[data-aed]'),function(s){
   var a=parseFloat(s.getAttribute('data-aed')),t=R?fmt(a*R.r,R):aed(a);
   if(s.textContent!==t)s.textContent=t;
  });
 }
 var tm=0;
 function run(){clearTimeout(tm);tm=setTimeout(function(){conv();rerender()},120)}
 new MutationObserver(run).observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['bucks-currency','bucks-current']});
 run();
 /* cart icon bump when the count changes */
 var last=null;
 function bump(){
  var c=document.querySelector('.cart-bubble__text-count');if(!c)return;
  var v=c.textContent.trim();
  if(last!==null&&v!==last){var i=document.querySelector('cart-icon');if(i){i.classList.remove('gbf-bump');void i.offsetWidth;i.classList.add('gbf-bump');setTimeout(function(){i.classList.remove('gbf-bump')},800)}}
  last=v;
 }
 setInterval(bump,700);bump();
 /* move the real-results block right under the product buy box */
 function place(){
  var p=document.getElementById('gbpf');if(!p||p.getAttribute('data-placed'))return;
  var main=document.querySelector('main#MainContent')||document.querySelector('main');
  var first=main&&main.querySelector('.shopify-section');
  if(!first||first.contains(p))return;
  first.parentNode.insertBefore(p,first.nextSibling);p.setAttribute('data-placed','1');
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',place);else place();
})();